import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PanelSection from './PanelSection';

type MetricsSectionProps = {
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  maxHeightClassName?: string;
};

/**
 * Collapsible Metrics block for object dimension fields in the property panel.
 */
const MetricsSection: React.FC<MetricsSectionProps> = ({
  children,
  defaultOpen = true,
  className = 'p-3',
  maxHeightClassName = 'max-h-none',
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);

  return (
    <PanelSection
      title={t('propertyPanel.metrics')}
      collapsible
      open={open}
      onToggle={() => setOpen(!open)}
      maxHeightClassName={maxHeightClassName}
      className={className}
    >
      <div className="space-y-0.5 px-3 pb-1 pt-0">{children}</div>
    </PanelSection>
  );
};

export default MetricsSection;
